import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaPlus } from "react-icons/fa";
import { addToGuestCart } from "../../util/guestCartService";
import { getProductImageUrl, handleProductImageError } from "../../util/storeLogoHelper";

const money = (value) => `Rs. ${Math.round(Number(value || 0)).toLocaleString()}`;

/**
 * "You may also like" for the cart: bundle partners of what is in it, then
 * products often bought with it, then the same categories. Products with
 * sizes or colors link to their page instead of being added blindly.
 */
export default function CartRecommendations({ items, title = "You may also like", compact = false, onNavigate }) {
  const [products, setProducts] = useState([]);
  const ids = useMemo(
    () => [...new Set((items || []).map((item) => Number(item.product_id || item.id)).filter(Boolean))].sort((a, b) => a - b).join(","),
    [items]
  );

  useEffect(() => {
    if (!ids) {
      setProducts([]);
      return undefined;
    }
    let active = true;
    const timer = setTimeout(() => {
      axios.get(`/api/cart-recommendations?ids=${ids}`)
        .then((res) => {
          if (active && res.data.status === 200) setProducts(res.data.products || []);
        })
        .catch(() => {});
    }, 200);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [ids]);

  if (!products.length) return null;
  const shown = products.slice(0, compact ? 4 : 6);

  return (
    <section className={`cart-recs ${compact ? "is-compact" : ""}`} aria-label={title}>
      <h6 className="cart-recs-title">{title}</h6>
      <div className="cart-recs-list">
        {shown.map((card) => {
          const href = `/collection/${card.category?.slug || "all"}/${card.slug}`;
          return (
            <div className="cart-recs-card" key={card.id}>
              <Link to={href} onClick={onNavigate} className="cart-recs-img">
                <img src={getProductImageUrl(card.image)} alt={card.name} loading="lazy" onError={handleProductImageError} />
              </Link>
              <div className="cart-recs-info">
                <Link to={href} onClick={onNavigate} className="cart-recs-name" title={card.name}>{card.name}</Link>
                <span className="cart-recs-price">
                  {card.compare_price ? <s>{money(card.compare_price)}</s> : null} {money(card.price)}
                </span>
              </div>
              {card.has_variants || !card.in_stock ? (
                <Link to={href} onClick={onNavigate} className="cart-recs-add is-link">{card.in_stock ? "Options" : "Sold out"}</Link>
              ) : (
                <button type="button" className="cart-recs-add" onClick={() => addToGuestCart(card, 1, null)} aria-label={`Add ${card.name}`}>
                  <FaPlus size={11} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
